<template>
  <div
    v-if="appStore.withdrawModal"
    id="withdrawModal"
    class="fixed inset-0 z-50 bg-black bg-opacity-80 flex items-center justify-center p-4"
  >
    <div class="bg-[#0C1020] w-full max-w-md rounded-2xl p-6 shadow-2xl border border-[#d600c0] relative text-white">
      <!-- Botão de fechar -->
      <button
        class="absolute top-3 right-3 text-white text-xl hover:text-gray-400"
        @click="appStore.withdrawModal = false"
      >
        ✕
      </button>

      <h2 class="text-2xl font-bold mb-2 text-center">Solicitar Saque</h2>
      <p class="text-gray-400 text-sm text-center mb-6">Escolha o valor e a moeda que deseja sacar.</p>

      <div class="space-y-4">
        <VaInput
          v-model="valor"
          type="number"
          label="Valor do Saque"
          color="#d600c0"
          class="w-full"
          :rules="[(v) => Number(v) > 0 || 'Informe um valor válido']"
        />

        <VaSelect v-model="moeda" label="Moeda" class="w-full" color="#d600c0" :options="['BRL', 'USDT']" />
        <small v-if="moeda === 'BRL'">Cotação: {{ taxFormatado }}</small>
        <small v-if="moeda === 'USDT'">Taxa para saque em USDT é de 2%</small>
        <VaButton
          color="#d600c0"
          class="w-full text-white font-semibold rounded-lg py-3"
          :loading="loading"
          @click="solicitarSaque"
        >
          Confirmar Saque
        </VaButton>
      </div>

      <p v-if="erro" class="text-red-500 text-sm mt-4 text-center">{{ erro }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { useAppStore } from '../../stores/integration'
import { useToast } from 'vuestic-ui'

const appStore = useAppStore()
const { init } = useToast()

const valor = ref(0)
const moeda = ref('BRL')
const erro = ref('')
const tax = ref(0)
const loading = ref(false)
const getTax = async () => {
  tax.value = await appStore.getTaxDolar(true)
}
const solicitarSaque = async () => {
  erro.value = ''
  if (valor.value <= 0) {
    erro.value = 'Informe um valor válido.'
    return
  }

  loading.value = true

  const res = await appStore.withdraw(valor.value, moeda.value.toLowerCase())

  if (res.success) {
    init({ message: res.message, color: 'success' })
  } else {
    erro.value = res.message
    init({ message: res.message, color: 'danger' })
  }

  loading.value = false
  appStore.hideWithdrawModal()
}

onMounted(() => {
  getTax()
})

const taxFormatado = computed(() =>
  Number(tax.value || 0).toLocaleString(undefined, {
    style: 'currency',
    currency: 'USD',
  }),
)
</script>
